<div class="counter-item">
  <div class="icon">
    <div class="counter-icon" [ngClass]="title">
      <div [ngClass]="getIcon()"></div>
    </div>
  </div>
  <div class="title">
    {{ title }}
    <span class="diff" [@diffToggle]="diffShow ? 'show' : 'hide'"
      [ngClass]="{'text-navy': diff > 0, 'text-danger': diff < 0}">{{ diff > 0 ? '+' : '' }}{{ diff }}</span>
  </div>
  <div class="counter">{{ val === undefined ? '0' : val | thousandseparate}}</div>
</div>
